import { render, staticRenderFns } from "./ResultsAttributes.vue?vue&type=template&id=47fb8636&"
import script from "./ResultsAttributes.vue?vue&type=script&lang=js&"
export * from "./ResultsAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports